export var PhotoshootType;
(function (PhotoshootType) {
    PhotoshootType[PhotoshootType["Head"] = 1];
    PhotoshootType[PhotoshootType["Body"] = 2];
})(PhotoshootType || (PhotoshootType = {}));